import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { OfferListingItemComponent } from '@features/offer-ui/components/offer-listing-item/offer-listing-item.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateService } from '@rd/core/services/date/date.service';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { BNZ_BANKWIDE_UPDATES_ENABLED } from '../../../core/tokens/features.tokens';

@Component({
  selector: 'bnz-offer-listing-item',
  styleUrls: [
    '../../../../../../../libs/features/offer/src/lib/offer-ui/components/offer-listing-item/offer-listing-item.component.scss',
    './offer-listing-item.component.scss',
  ],
  template: `
    <a
      class="hover-tile focus-link container rounded-md hover:outline hover:outline-[#007dbc]"
      [routerLink]="url"
      [queryParams]="{ source: source }"
      [queryParamsHandling]="'merge'"
      [attr.aria-label]="
        'accessibility.offer.list_item_aria_label'
          | translate: { title: this.title, brand: this.brand }
      ">
      <div class="cover" [ngClass]="imageRatioClass()">
        <img
          class="h-full w-full object-cover object-center"
          [src]="coverImage" />
        <div class="category-icon-container" *ngIf="renderCategoryIcon">
          <rd-shared-icon
            class="offer-category-icon"
            [iconSymbol]="categoryIcon"
            [iconTheme]="'primary'"></rd-shared-icon>
        </div>
      </div>
      <div class="content">
        <div class="offer-text">
          <h3 class="offer-brand">{{ brand }}</h3>
          <h4 class="offer-title">{{ title }}</h4>
          <div class="ml-1.5 mt-2 flex flex-row items-center" *ngIf="validity">
            <rd-shared-icon
              class="flex h-3 w-3"
              [iconSymbol]="'icon-validity'"></rd-shared-icon>
            <div class="text-xs ltr:ml-1.5 rtl:mr-1.5">
              {{ validity }}
            </div>
          </div>
        </div>
        <div class="logo-wrapper" *ngIf="logo">
          <img class="logo" [src]="logo" [alt]="brand + ' logo'" />
        </div>
      </div>
    </a>
  `,
  imports: [CommonModule, IconModule, RouterModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BnzOfferItemComponent extends OfferListingItemComponent {
  @Input() expiryTime?: string;
  @Input() source?: string;

  private dateService = inject(DateService);
  private translateService = inject(TranslateService);
  isBnzBankwideUpdatesEnabled = inject(BNZ_BANKWIDE_UPDATES_ENABLED);

  get validity(): string | null {
    if (this.source === 'points_boost') {
      return null;
    }
    if (this.expiryTime) {
      return this.translateService.instant('offer.details.validity', {
        expiryDate: this.dateService.formatDate(this.expiryTime, 'd MMMM yyyy'),
      });
    }
    return null;
  }
}
